export default "{\n    \"emailLabel\": \"Email\",\n    \"pushLabel\": \"App\",\n    \"smsLabel\": \"Text\"\n}\n"